import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, Navigate, useSearchParams } from 'react-router-dom';
import { UserProvider, useUser } from './context/UserContext';
import Login from './pages/Login';
import CambioClave from './pages/CambioClave';
import RestablecerClave from './pages/RestablecerClave';
import Layout from './layouts/Layout';
import Inicio from './pages/Inicio';
import DetalleCesion from './pages/DetalleCesion';
import CarteraEjecutivo from './pages/CarteraEjecutivo';
import DetalleEjecutivo from './pages/DetalleEjecutivo';
import DetalleCliente from './pages/DetalleCliente';
import Usuarios from './pages/Usuarios';
import GestionUsuarios from './pages/GestionUsuarios';
import AdministracionMetas from './pages/AdministracionMetas';
import MetaPresupuestoGerencia from './pages/MetaPresupuestoGerencia';
import SyncEjecHist from './pages/SyncEjecHist';
import IngresarTuboNegocio from './pages/IngresarTuboNegocio';
import BolsaDocumentos from './pages/BolsaDocumentos';
import Campanas from './pages/Campanas';
import EnGestion from './pages/EnGestion';
import Perdidos from './pages/Perdidos';
import IngresarLeads from './pages/IngresarLeads';
import CargaMasivaLeads from './pages/CargaMasivaLeads';
import Factoring from './pages/Factoring';
import Credito from './pages/Credito';
import Leasing from './pages/Leasing';
import DetalleOtorgamientos from './pages/DetalleOtorgamientos';
import DetalleRecaudaciones from './pages/DetalleRecaudaciones';
import DetalleDevolucionesManuales from './pages/DetalleDevolucionesManuales';
import DetalleSeguimientoEjecutivo from './pages/DetalleSeguimientoEjecutivo';
import IngresarDevolucionesManuales from './pages/IngresarDevolucionesManuales';
import IngresarMetas from './pages/IngresarMetas';
import CrearReporteDiario from './pages/CrearReporteDiario';
import SimuladorOperaciones from './pages/SimuladorOperaciones';
import CotizadorFactoring from './pages/CotizadorFactoring';
import ListadoCotizaciones from './pages/CotizadorFactoring/ListadoCotizaciones';
import ResultadoSimulacion from './pages/ResultadoSimulacion';
import ListadoSimulacion from './pages/ListadoSimulacion';
import BuscadorClientes from './pages/BuscadorClientes';
import ConsultaOtorgamientos from './pages/ConsultaOtorgamientos';
import AnalisisPrecios from './pages/AnalisisPrecios';
import SeguimientoCesionesFacturacion from './pages/SeguimientoCesionesFacturacion';
import PanelComercial from './pages/PanelComercial';
import PanelGerencial from './pages/PanelGerencial';
import SimuladorMoraExcepcion from './pages/SimuladorMoraExcepcion';
import SolicitudesExcepcionMora from './pages/SolicitudesExcepcionMora';
import MarketingPlaceholderUno from './pages/MarketingPlaceholderUno';
import PanelDetalleOtoFuentes from './pages/PanelDetalleOtoFuentes';
import CargaCampana from './pages/CargaCampana';
import CargaMetaVolumenMensual from './pages/CargaMetaVolumenMensual';
import MantenedorSubgerentes from './pages/MantenedorSubgerentes';
import AccionesCampana from './pages/AccionesCampana';
import PanelNoOperados from './pages/PanelNoOperados';
import ConnectTarjetas from './pages/ConnectTarjetas';
import ConnectRegistros from './pages/ConnectRegistros';
import ConnectTarjetaPublica from './pages/ConnectTarjetaPublica';
import ClasificacionRuts from './pages/ClasificacionRuts';
import VentaAnual from './pages/VentaAnual';
import PruebaSofia from './pages/PruebaSofia';
import { canAccessNoOperados } from './utils/gestionCampanaAccess';
import RequireNoOperadosAccess from './components/RequireNoOperadosAccess';
import ProtectedRoute from './components/ProtectedRoute';
import RequireGestionCampanaAccess from './components/RequireGestionCampanaAccess';
import RequireClasificacionRutsAccess from './components/RequireClasificacionRutsAccess';
import RequireVentaAnualAccess from './components/RequireVentaAnualAccess';
import RequireCargaMasivaLeadsAccess from './components/RequireCargaMasivaLeadsAccess';
import RequirePruebaSofiaAccess from './components/RequirePruebaSofiaAccess';
import RequireCotizadorFactoringAccess from './components/RequireCotizadorFactoringAccess';
import RequireConsultaOtorgamientosAccess from './components/RequireConsultaOtorgamientosAccess';
import RequireAnalisisPreciosAccess from './components/RequireAnalisisPreciosAccess';
import RequireSeguimientoCesionesFacturacionAccess from './components/RequireSeguimientoCesionesFacturacionAccess';
import RequirePanelComercialAccess from './components/RequirePanelComercialAccess';
import RequireSolicitudesExcepcionMoraAccess from './components/RequireSolicitudesExcepcionMoraAccess';
import RequireTasasMoraPreacordadasAccess from './components/RequireTasasMoraPreacordadasAccess';
import RequireSimuladorMoraAccess from './components/RequireSimuladorMoraAccess';
import RequirePermissionDebugAccess from './components/RequirePermissionDebugAccess';
import RequireRecapturaAccess from './components/RequireRecapturaAccess';
import TasasMoraPreacordadas from './pages/TasasMoraPreacordadas';
import DebugPermisos from './pages/DebugPermisos';
import DeepLinkHandler from './components/DeepLinkHandler';
import RecapturaMatriz from './pages/recaptura/RecapturaMatriz';
import RecapturaFicha from './pages/recaptura/RecapturaFicha';
import RecapturaResumen from './pages/recaptura/RecapturaResumen';
import RecapturaAprobaciones from './pages/recaptura/RecapturaAprobaciones';
import RecapturaBitacora from './pages/recaptura/RecapturaBitacora';
import RecapturaCarga from './pages/recaptura/RecapturaCarga';
import { consumePendingDeepLink, captureDeepLinkFromLocation } from './utils/deepLink';
import { defaultHomePath } from './utils/gestionCampanaAccess';
import './index.css';

function LoginWrapper() {
  const navigate = useNavigate();

  return (
    <Login
      onShowRegister={() => navigate('/register')}
      onShowCambioClave={() => navigate('/cambioclave')}
      onShowRestablecerClave={() => navigate('/restablecer-clave')}
      onLoginSuccess={(user) => {
        captureDeepLinkFromLocation(window.location.search);
        const pending = consumePendingDeepLink();
        navigate(pending || defaultHomePath(user));
      }}
    />
  );
}

function RegisterWrapper() {
  const navigate = useNavigate();
  return <CambioClave onBackToLogin={() => navigate('/login')} />;
}

function RestablecerWrapper() {
  const navigate = useNavigate();
  return <RestablecerClave onBackToLogin={() => navigate('/login')} />;
}

function RootRedirect() {
  const { user, realUser } = useUser();
  const [params] = useSearchParams();
  const connectSlug = (params.get('c') || '').trim();
  if (connectSlug) {
    return <ConnectTarjetaPublica />;
  }
  const target = captureDeepLinkFromLocation(window.location.search);

  if (realUser && target) {
    return <Navigate to={consumePendingDeepLink() || target} replace />;
  }
  if (realUser) {
    return <Navigate to={defaultHomePath(user)} replace />;
  }
  // Sin sesión: guarda el deep link y pide login
  return <Navigate to="/login" replace />;
}

function App() {
  return (
    <UserProvider>
      <Router>
      <DeepLinkHandler />
      <Routes>
        {/* Rutas públicas */}
        <Route
          path="/login"
          element={<LoginWrapper />}
        />
        <Route
          path="/cambioclave"
          element={<RegisterWrapper />}
        />
        <Route
          path="/restablecer-clave"
          element={<RestablecerWrapper />}
        />
        <Route path="/c/:slug" element={<ConnectTarjetaPublica />} />
        <Route path="/index.html" element={<RootRedirect />} />

        {/* Ruta raíz: captura deep link del correo y manda a login */}
        <Route
          path="/"
          element={<RootRedirect />}
        />

        {/* Rutas privadas */}
        <Route path="/inicio" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<Inicio />} />
        </Route>
        <Route path="/detalle-cesion" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<DetalleCesion />} />
        </Route>
        <Route path="/cartera-ejecutivo" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<CarteraEjecutivo />} />
        </Route>
        <Route path="/detalle-ejecutivo/:id" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<DetalleEjecutivo />} />
        </Route>
        <Route path="/detalle-cliente/:rut" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<DetalleCliente />} />
        </Route>

        <Route path="/usuarios" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<Usuarios />} />
          <Route path="nuevo" element={<Navigate to="/usuarios/gestion" replace />} />
          <Route path="gestion" element={<GestionUsuarios />} />
          <Route
            path="administracion-metas"
            element={
              <ProtectedRoute allowedRoles={['Administrador']}>
                <AdministracionMetas />
              </ProtectedRoute>
            }
          />
          <Route
            path="meta-presupuesto-gerencia"
            element={
              <ProtectedRoute allowedRoles={['Administrador']}>
                <MetaPresupuestoGerencia />
              </ProtectedRoute>
            }
          />
          <Route
            path="sync-ejec-hist"
            element={
              <ProtectedRoute allowedRoles={['Administrador']}>
                <SyncEjecHist />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route path="/ingresar-tubo-negocio" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<IngresarTuboNegocio />} />
        </Route>
        <Route path="/bolsa-documentos" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<BolsaDocumentos />} />
        </Route>
        <Route path="/campanas" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<Campanas />} />
        </Route>

        {/* Recaptura */}
        <Route path="/recaptura/matriz" element={<ProtectedRoute><RequireRecapturaAccess mode="operativo"><Layout /></RequireRecapturaAccess></ProtectedRoute>}>
          <Route index element={<RecapturaMatriz />} />
        </Route>
        <Route path="/recaptura/ficha/:rut" element={<ProtectedRoute><RequireRecapturaAccess mode="operativo"><Layout /></RequireRecapturaAccess></ProtectedRoute>}>
          <Route index element={<RecapturaFicha />} />
        </Route>
        <Route path="/recaptura/bitacora" element={<ProtectedRoute><RequireRecapturaAccess mode="operativo"><Layout /></RequireRecapturaAccess></ProtectedRoute>}>
          <Route index element={<RecapturaBitacora />} />
        </Route>
        <Route path="/recaptura/resumen" element={<ProtectedRoute><RequireRecapturaAccess mode="resumen"><Layout /></RequireRecapturaAccess></ProtectedRoute>}>
          <Route index element={<RecapturaResumen />} />
        </Route>
        <Route path="/recaptura/aprobaciones" element={<ProtectedRoute><RequireRecapturaAccess mode="aprobaciones"><Layout /></RequireRecapturaAccess></ProtectedRoute>}>
          <Route index element={<RecapturaAprobaciones />} />
        </Route>
        <Route path="/recaptura/carga" element={<ProtectedRoute><RequireRecapturaAccess mode="carga"><Layout /></RequireRecapturaAccess></ProtectedRoute>}>
          <Route index element={<RecapturaCarga />} />
        </Route>
        <Route path="/en-gestion" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<EnGestion />} />
        </Route>
        <Route path="/perdidos" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<Perdidos />} />
        </Route>
        <Route path="/ingresar-registro" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<IngresarLeads />} />
        </Route>
        <Route path="/carga-masiva-leads" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route
            index
            element={
              <RequireCargaMasivaLeadsAccess>
                <CargaMasivaLeads />
              </RequireCargaMasivaLeadsAccess>
            }
          />
        </Route>
        <Route path="/factoring" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<Factoring />} />
        </Route>
        <Route path="/credito" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<Credito />} />
        </Route>
        <Route path="/leasing" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<Leasing />} />
        </Route>
        <Route path="/detalle-otorgamientos" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<DetalleOtorgamientos />} />
        </Route>
        <Route path="/detalle-recaudaciones" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<DetalleRecaudaciones />} />
        </Route>
        <Route path="/detalle-devoluciones-manuales" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<DetalleDevolucionesManuales />} />
        </Route>
        <Route path="/detalle-seguimiento-ejecutivo" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<DetalleSeguimientoEjecutivo />} />
        </Route>
        <Route path="/crear-reporte-diario" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<CrearReporteDiario />} />
        </Route>
        <Route path="/ingresar-devoluciones-manuales" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<IngresarDevolucionesManuales />} />
        </Route>
        <Route path="/ingresar-metas" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<IngresarMetas />} />
        </Route>
        <Route path="/simulador-operaciones" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<SimuladorOperaciones />} />
        </Route>
        <Route path="/listado-simulacion" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<ListadoSimulacion />} />
        </Route>
        <Route path="/buscador-clientes" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<BuscadorClientes />} />
        </Route>
        <Route
          path="/consulta-otorgamientos"
          element={
            <ProtectedRoute>
              <RequireConsultaOtorgamientosAccess>
                <Layout />
              </RequireConsultaOtorgamientosAccess>
            </ProtectedRoute>
          }
        >
          <Route index element={<ConsultaOtorgamientos />} />
        </Route>
        <Route
          path="/analisis-precios"
          element={
            <ProtectedRoute>
              <RequireAnalisisPreciosAccess>
                <Layout />
              </RequireAnalisisPreciosAccess>
            </ProtectedRoute>
          }
        >
          <Route index element={<AnalisisPrecios />} />
        </Route>
        <Route
          path="/seguimiento-cesiones-facturacion"
          element={
            <ProtectedRoute>
              <RequireSeguimientoCesionesFacturacionAccess>
                <Layout />
              </RequireSeguimientoCesionesFacturacionAccess>
            </ProtectedRoute>
          }
        >
          <Route index element={<SeguimientoCesionesFacturacion />} />
        </Route>
        <Route
          path="/panel-comercial"
          element={
            <ProtectedRoute>
              <RequirePanelComercialAccess>
                <Layout />
              </RequirePanelComercialAccess>
            </ProtectedRoute>
          }
        >
          <Route index element={<PanelComercial />} />
        </Route>
        <Route
          path="/panel-gerencial"
          element={
            <ProtectedRoute>
              <RequirePanelComercialAccess>
                <Layout />
              </RequirePanelComercialAccess>
            </ProtectedRoute>
          }
        >
          <Route index element={<PanelGerencial />} />
        </Route>
        <Route
          path="/simulador-mora-excepcion"
          element={
            <ProtectedRoute>
              <RequireSimuladorMoraAccess>
                <Layout />
              </RequireSimuladorMoraAccess>
            </ProtectedRoute>
          }
        >
          <Route index element={<SimuladorMoraExcepcion />} />
        </Route>
        <Route
          path="/solicitudes-excepcion-mora"
          element={
            <ProtectedRoute>
              <RequireSolicitudesExcepcionMoraAccess>
                <Layout />
              </RequireSolicitudesExcepcionMoraAccess>
            </ProtectedRoute>
          }
        >
          <Route index element={<SolicitudesExcepcionMora />} />
        </Route>
        <Route
          path="/tasas-mora-preacordadas"
          element={
            <ProtectedRoute>
              <RequireTasasMoraPreacordadasAccess>
                <Layout />
              </RequireTasasMoraPreacordadasAccess>
            </ProtectedRoute>
          }
        >
          <Route index element={<TasasMoraPreacordadas />} />
        </Route>
        <Route path="/resultado-simulacion" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<ResultadoSimulacion />} />
        </Route>
        <Route path="/cotizador-factoring" element={<ProtectedRoute><RequireCotizadorFactoringAccess><Layout /></RequireCotizadorFactoringAccess></ProtectedRoute>}>
          <Route index element={<CotizadorFactoring />} />
          <Route path="listado" element={<ListadoCotizaciones />} />
        </Route>

        {/* Gestión Campaña: Administrador o ids en utils/gestionCampanaAccess.js */}
        <Route path="/panel-marketing/placeholder-1" element={<ProtectedRoute><RequireGestionCampanaAccess><Layout /></RequireGestionCampanaAccess></ProtectedRoute>}>
          <Route index element={<MarketingPlaceholderUno />} />
        </Route>
        <Route path="/panel-marketing/fuentes-datos" element={<ProtectedRoute><RequireGestionCampanaAccess><Layout /></RequireGestionCampanaAccess></ProtectedRoute>}>
          <Route index element={<PanelDetalleOtoFuentes />} />
        </Route>
        <Route path="/panel-marketing/carga-campana" element={<ProtectedRoute><RequireGestionCampanaAccess><Layout /></RequireGestionCampanaAccess></ProtectedRoute>}>
          <Route index element={<CargaCampana />} />
        </Route>
        <Route path="/panel-marketing/carga-meta-volumen" element={<ProtectedRoute><RequireGestionCampanaAccess><Layout /></RequireGestionCampanaAccess></ProtectedRoute>}>
          <Route index element={<CargaMetaVolumenMensual />} />
        </Route>
        <Route path="/panel-marketing/mantenedor-subgerentes" element={<ProtectedRoute><RequireGestionCampanaAccess><Layout /></RequireGestionCampanaAccess></ProtectedRoute>}>
          <Route index element={<MantenedorSubgerentes />} />
        </Route>
        <Route path="/panel-marketing/connect-tarjetas" element={<ProtectedRoute><RequireGestionCampanaAccess><Layout /></RequireGestionCampanaAccess></ProtectedRoute>}>
          <Route index element={<ConnectTarjetas />} />
        </Route>
        <Route path="/panel-marketing/connect-registros" element={<ProtectedRoute><RequireGestionCampanaAccess><Layout /></RequireGestionCampanaAccess></ProtectedRoute>}>
          <Route index element={<ConnectRegistros />} />
        </Route>
        <Route path="/panel-marketing/acciones-campana" element={<ProtectedRoute><RequireGestionCampanaAccess><Layout /></RequireGestionCampanaAccess></ProtectedRoute>}>
          <Route index element={<AccionesCampana />} />
        </Route>
        <Route path="/panel-marketing/seguimiento-ejecutivo" element={<ProtectedRoute><RequirePruebaSofiaAccess><Layout /></RequirePruebaSofiaAccess></ProtectedRoute>}>
          <Route index element={<PruebaSofia />} />
        </Route>
        <Route path="/panel-marketing/prueba-sofia" element={<Navigate to="/panel-marketing/seguimiento-ejecutivo" replace />} />
        <Route path="/panel-marketing/no-operados" element={<ProtectedRoute><RequireNoOperadosAccess><Layout /></RequireNoOperadosAccess></ProtectedRoute>}>
          <Route index element={<PanelNoOperados />} />
        </Route>

        {/* Control de gestión → Clasificación RUTs / Venta anual */}
        <Route path="/control-gestion/clasificacion-ruts" element={<ProtectedRoute><RequireClasificacionRutsAccess><Layout /></RequireClasificacionRutsAccess></ProtectedRoute>}>
          <Route index element={<ClasificacionRuts />} />
        </Route>
        <Route path="/control-gestion/venta-anual" element={<ProtectedRoute><RequireVentaAnualAccess><Layout /></RequireVentaAnualAccess></ProtectedRoute>}>
          <Route index element={<VentaAnual />} />
        </Route>
        <Route path="/clasificacion-ruts" element={<Navigate to="/control-gestion/clasificacion-ruts" replace />} />
        <Route path="/panel-marketing/clasificacion-ruts" element={<Navigate to="/control-gestion/clasificacion-ruts" replace />} />

        <Route
          path="/debug-permisos"
          element={
            <ProtectedRoute>
              <RequirePermissionDebugAccess>
                <Layout />
              </RequirePermissionDebugAccess>
            </ProtectedRoute>
          }
        >
          <Route index element={<DebugPermisos />} />
        </Route>

        {/* Catch-all route - redirige a login */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
      </Router>
    </UserProvider>
  );
}

export default App;
